<template>
  <section class="login_container">
    <div>
      <nav class="login-nav" style="background-color:#cc2128 !important;">
        <b-container fluid>
          <b-row class="justify-content-center">
            <b-col cols="4">
              <div class="text-center">
                <a href="https://www.makita.com.mx/">
                  <img
                     src="../assets/logotipo_makita_rojo.png" 
                    fluid
                    alt="makita logo" width="219" height="73"
                  />
                </a>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </nav>
    </div>
    <div class="garantia_container">
      <b-container>
        <b-row>
          <b-col cols="12">
            <h2>GARANTÍA MAKITA EXTENDIDA 6 MESES</h2>
            <p>Cada herramienta Makita está cuidadosamente inspeccionada y probada antes salir de nuestras fábricas, no obstante se garantiza por el periodo de UN AÑO a partir de la fecha de compra, contra cualquier defecto de fábrica así como en materiales y mano de obra.</p>
            <p>
              De surgir algún problema durante este periodo, puede llevar su herramienta a uno de los Centros de
              <a
                href="#"
                target="_blank"
              >Servicios Autorizados Makita</a>. De resultar algún problema de funcionamiento ó componentes, Makita México, S.A. de C.V., reemplazará el producto de ser necesario o cualquier pieza defectuosa, incluyendo la mano de obra, así como los gastos de transportación del producto dentro de la red de servicio de Makita.
            </p>
            <div style="text-align:center; margin: 20px 0;">
                <img alt src="../assets/banner-Garantia_1920x660px.jpg" width="780" height="300px" />
            </div>
            
            <p>El registro de su herramienta por medio de este formulario le da derecho a un período de GARANTIA EXTENDIDA DE 6 MESES adicionales al año de garantía estipulado en su PÓLIZA y es aplicable bajo los siguientes términos:</p>
            <ul>
              <li>Es necesario que al momento de la compra de la herramienta se realice el REGISTRO, cuando aún está VIGENTE LA GARANTIA DE UN AÑO.</li>
              <li>Se puede hacer uso de los servicios de MANTENIMIENTO Y REPARACIÓN en cualquiera de nuestros Centros de Servicios Autorizados Makita dentro de la República Mexicana.</li>
              <li>Es indispensable llevar su comprobante de registro de Garantía Extendida de 6 Meses y PÓLIZA o FACTURA para hacer uso de los servicios de mantenimiento y reparación.</li>
            </ul>

            <h4>Pasos para el registro de cada herramienta</h4>
            <ol>
              <li>Ingrese sus datos y verifique que estén correctos, en especial su correo y el número de serie de su herramienta.</li>
              <li>A continuación, verifique que le ha recibido en su correo el COMPROBANTE DE REGISTRO en formato PDF, el cual puede imprimir.</li>
            </ol>
          </b-col>
          <b-col class="mb-5">
            <div class="header">
              <b-row>
                <b-col cols="12">
                  <fieldset class="fieldset">
                    <p>*En algunas circunstancias el correo con la garantía extendida puede llegar a la bandeja de correo no deseado, SPAM, por lo que le sugerimos revisar su correo y en caso marcarlo como seguro para que pueda descargar correctamente la extensión de garantía.</p>
                  </fieldset>
                </b-col>
              </b-row>
            </div>
            <div class="content">
              <Form
                ref="form"
                v-if="formData"
                v-model="formData"
                class="dashboard-form"
                :disabled="loading"
                :config="garantiaFormConfig"
                @submit="onSubmit()"
                @validRecaptcha="validRecaptcha"
                @onFileChange="onFileChange"
              >
                <template slot="titleText" slot-scope="props">
                  <h4 v-if="props.fieldTitleText" class="title my-4 ml-2">{{ props.fieldTitleText }}</h4>
                </template>
              </Form>
              <Loader v-if="loading" color="#66605a" class="mt-4" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import Form from "@/components/form.vue";
import Loader from "@/components/general/Loader.vue";

import { mapActions } from "vuex";
export default {
  components: {
    Form,
    Loader
  },
  data() {
    return {
      recaptcha: false,
      loading: false,
      distribuidores: [],
      distribuidorSelected: null,
      isOtherDis: false,
      formData: {},
      imageFile: null,
      garantiaFormConfig: {
        fields: [
          {
            label: "Nombre del propietario*",
            name: "nombre",
            text: "nombre del propietario",
            type: "text",
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "E-mail*",
            name: "email",
            text: "E-mail",
            type: "email",
            rules: {
              required: true,
              email: true
            },
            sm: "6"
          },
          {
            label: "Nombre de la herramienta*",
            name: "nomHerr",
            text: "nombre de la herramienta",
            type: "text",
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "Modelo herramienta*",
            name: "modHerr",
            text: "modelo",
            type: "text",
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "Numero de serie*",
            name: "numSerie",
            text: "numero de serie",
            type: "text",
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "Estado*",
            name: "state",
            text: "Estado",
            type: "select",
            options: [],
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "Distribuidor Autorizado *",
            name: "nomDis",
            text: "distribuidor Autorizado",
            type: "select",
            options: [],
            rules: {
              required: true
            },
            sm: "6"
          },
          {
            label: "Dirección del distribuidor",
            name: "dirDis",
            text: "distribuidor del distribuidor",
            type: "text",
            disabled: true
          },
          {
            label: "# de factura o comprobante",
            name: "numFac",
            text: "numero de factura",
            type: "text",
            rules: {
              required: true
            }
          }
        ],
        disabledButton: !this.recaptcha,
        recaptcha: true,
        floatingLabels: true,
        autocomplete: false,
        submitText: "Aceptar",
        submitClasses: "main-btn text-uppercase mt-3"
      },
      extraFields: [
        {
          label: "Nombre del distribuidor",
          text: "Nombre del distribuidor",
          name: "customDisName",
          type: "text",
          rules: {
            required: true
          }
        },
        {
          name: "file",
          text: "Comprobante de pago",
          type: "file"
        }
      ]
    };
  },
  watch: {
    async "formData.state"(value) {
      if (value) {
        try {
          const res = await this.axios.post("/getDistribuidorPorEstado.php", {
            idEstado: value
          });
          if (res.status === 200) {
            this.distribuidores = res.data.distribuidores;
            const disSelectOpts = res.data.distribuidores.map(item => {
              return {
                value: item.idDistribuidor,
                text: item.nombreDistribuidor
              };
            });
            disSelectOpts.push({
              value: "other",
              text: "Otro"
            });
            this.garantiaFormConfig.fields.forEach(item => {
              if (item.name === "nomDis") item.options = disSelectOpts;
            });
            this.formData.nomDis = disSelectOpts[0].value;
            this.setCurrentDistribuidor(disSelectOpts[0].value);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async "formData.nomDis"(value) {
      if (value !== "other") {
        this.setCurrentDistribuidor(value);
        this.garantiaFormConfig.fields.forEach(item => {
          if (item.name === "dirDis") item.disabled = true;
        });

        this.garantiaFormConfig.fields = this.garantiaFormConfig.fields.filter(
          ele => ele.name !== "file" && ele.name !== "customDisName"
        );
        this.imageFile = null;
      } else {
        // Habilitar los campos para colocar un distribuidor
        this.isOtherDis = true;
        this.garantiaFormConfig.fields.forEach(item => {
          if (item.name === "dirDis") item.disabled = false;
        });
        this.garantiaFormConfig.fields.push(...this.extraFields);
        this.formData.dirDis = "";
      }
    }
  },
  async mounted() {
    try {
      const res = await this.axios.get("/getEstados.php");
      if (res.status === 200) {
        const estados = res.data.estados.map(item => {
          return { value: item.idEstado, text: item.Estado };
        });
        this.garantiaFormConfig.fields.forEach(item => {
          if (item.name === "state") item.options = estados;
        });
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    ...mapActions("ui", ["makeAlert", "makeToast"]),
    onFileChange(ev) {
      const files = ev.target.files || ev.dataTransfer.files;
      this.imageFile = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    validRecaptcha() {
      this.recaptcha = true;
      this.garantiaFormConfig.disabledButton = false;
    },
    async onSubmit() {
      try {
        const formData = new FormData();
        formData.append("nombre", this.formData.nombre);
        formData.append("email", this.formData.email);
        formData.append("modHerr", this.formData.modHerr);
        formData.append("nomHerr", this.formData.nomHerr);
        formData.append("numFac", this.formData.numFac);
        formData.append("numSerie", this.formData.numSerie);
        formData.append("dirDis", this.formData.dirDis);
        let nombreDistribuidor = this.distribuidorSelected.nombreDistribuidor;
        if (this.formData.nomDis === "other") {
          nombreDistribuidor = this.formData.customDisName;
          //data.image = this.imageFile;
          formData.append("image", this.imageFile);
        }
        formData.append("nomDis", nombreDistribuidor);

        this.loading = true;

        const response = await this.axios.post("/generarPdf.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        if (response.status === 200) {
          this.makeAlert({
            title: "Garantía creada con éxito",
            text:
              "Se te ha enviado una copia de la garantia a tu correo electronico, revisa tu bandeja de entrada"
          }).then(async res => {
            if (res.value) {
              var byteCharacters = atob(response.data);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              var file = new Blob([byteArray], {
                type: "application/pdf;base64"
              });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            }
          });

          // this.clearForm();
        }
      } catch (error) {
        this.makeToast({
          icon: "error",
          title: "Fallo al intentar enviar el correo."
        });
      } finally {
        this.loading = false;
      }
    },
    setCurrentDistribuidor(idDistribuidor) {
      const result = this.distribuidores.filter(
        item => item.idDistribuidor === idDistribuidor
      )[0];
      if (result) {
        this.distribuidorSelected = result;
        this.formData.dirDis = this.distribuidorSelected.direccionDistribuidor;
      }
    },
    clearForm() {
      this.formData = {};
      this.garantiaFormConfig.fields.forEach(item => {
        if (item.name === "nomDis") {
          item.options = [];
        }
      });
      this.$refs.form.$refs.observer.reset();
    }
  }
};
</script>

<style lang="scss" >
.login_container {
  height: 100%;
  background-color: #f5f5f59e;
  & p {
    font-size: 1.3rem;
    text-align: justify;
  }
  & li {
    font-size: 1.1rem;
  }
}
.login-nav {
  padding: 1rem;
  background-color: #e53631;
  display: flex;
  align-items: center;
  box-shadow: 0px 10px 10px -4px rgba(0, 0, 0, 0.75);
}
.garantia_container {
  width: 100vw;

  display: flex;
  align-items: center;
  margin-top: 2rem;
}
.fieldset {
  font-size: 1.1rem;
}

.custom-select,
.form-control:focus {
  background-color: #f9f9f9 !important;
}
</style>